<template>
  <section :class="[ 'header',{ 'embedded': isEmbedded }]" >
    <div
      v-if="$route.name !== 'home' && !isEmbedded "
      @click="$router.push(`/`)"
      class="back-button"
    >
      <span class="mdi mdi-chevron-left icon-scale bigger" style="line-height: 2px;"></span>
      กลับหน้าหลัก
    </div>
    <div v-else class="empty-nav"></div>
    <div class="qr-code-container" @click="openQRCodePopup()">
      <div class="qr-code">
        <img src="../assets/img/qr-code.png" alt />
      </div>
    </div>
    <div  :class="[ 'user-info-container columns is-mobile',{ 'embedded': isEmbedded }]">
      <div class="column is-3 avatar">
        <img :src="require(`@/assets/img/${avatarType}-avatar.png`)" alt />
      </div>
      <div class="column" >
        <p class="hello" :style="{ fontSize: fontHello  }">สวัสดี</p>
        <p class="name" :style="{ fontSize: fontName  }">{{ patientName }}</p>
        <p class="hn" :style="{ fontSize: fontHN  }" v-if="hn" ref="hn">HN {{ hn }}</p>
        <!-- <p v-else class="hn">เลขประจำตัวประชาชน {{ pid }}</p> -->
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import qrCodePopup from '../components/qrCodePopup'

const props = {
  logo: {
    type: String,
    default: 'logo.svg'
  },
  isGradient: {
    type: Boolean,
    default: true
  },
  background1: {
    type: String,
    default: '#2A5C84'
  },
  background2: {
    type: String,
    default: '#3F8A8A'
  }
}
export default {
  name: 'NavBar',
  props,

  data () {
    return {
      isEmbedded: process.env.VUE_APP_EMBEDDED === 'true',
      fontHello: '',
      fontName: '',
      fontHN: ''
    }
  },
  mounted () {
    if (this.isEmbedded) {
      this.fontHello = '64px'
      this.fontName = '3.125rem'
      this.fontHN = '3rem'
    }
  },
  computed: {
    ...mapState(['patientName', 'hn', 'pid', 'patientGender', 'publicPath']),
    background () {
      return this.isGradient
        ? `linear-gradient(98deg, ${this.background1}, ${this.background2})`
        : `${this.background1}`
    },
    avatarType () {
      switch (this.patientGender) {
        case 'male':
          return 'young-man'
        case 'female':
          return 'young-woman'
        default:
          return 'anonymous'
      }
    }
  },
  methods: {
    openQRCodePopup () {
      this.$buefy.modal.open({
        parent: this,
        component: qrCodePopup
      })
    }
  }
}
</script>

<style lang="scss" scoped>
section.header {
  z-index: 9;
  position: fixed;
  height: 120px;
  width: 100%;
  background-image: linear-gradient(to bottom, #00958f, #087470);
  border-bottom-left-radius: 50px;
  color: white;

  &.embedded {
    background-color: #4a7a6b;
    border-radius: 0;
    background-image: none !important;
    position:relative;
    height:auto;

    .qr-code-container{
      display:none;
    }
  }

  .back-button {
    display: flex;
    align-items: center;
    font-family: "Mitr", sans-serif;
    font-size: 0.875rem;
    margin: 0.4rem 0.75rem;
  }

  .empty-nav {
    height: 33.8px;
  }

  .qr-code-container {
    position: absolute;
    right: 1.5rem;

    .qr-code {
      display: flex;
      padding: 4px;
      border-radius: 6px;
      background-color: #ffffff;
      cursor: pointer;
    }
  }

  .user-info-container {
    padding: 0 1rem;
    height: 100px;
    &.embedded{
      height:auto;
      .avatar{
        img{
          width:60%
        }
      }
    }
    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 60px;
      }
    }

    .hello {
      font-family: "Mitr", sans-serif;
      font-size: 20px;
    }

    .name {
      font-family: "Prajad", sans-serif;
      font-size: 1.125rem;
      font-weight: bold;
    }

    .hn {
      font-family: "Prajad", sans-serif;
      font-size: 1rem;
    }
  }
}
</style>
